import React from 'react';
import PropTypes from 'prop-types';

import ArrowIcon from '@material-ui/icons/PlayArrow';
import FaxIcon from '@material-ui/icons/PermPhoneMsg';
import PhoneIcon from '@material-ui/icons/Phone';

import Icon from '@components/Icon/Icon';

import './ContactAddress.scss';

const ContactAddress = ({
  contactDetails: {
    address,
    fax,
    phone,
  },
}) => (
  <div className="contact-address">
    {address && address.length > 0 && (
      <React.Fragment>
        <Icon className="contact-address__arrow-icon">
          <ArrowIcon />
        </Icon>
        <div className="contact-address__list">
          {address.map(({
            city,
            country,
            postalcode,
            state,
            street,
          }, index) => (
            <div
              className="contact-address__list-item"
              key={index}
            >
              {street}
              <br />
              {city}, {state} {postalcode}
              <br />
              {country}
            </div>
          ))}
        </div>
      </React.Fragment>
    )}
    <div className="contact-address__contact-group">
      {phone && (
        <div className="contact-address__contact-row">
          <Icon className="contact-address__icon">
            <PhoneIcon />
          </Icon>
          <div className="contact-address__text">
            {phone}
          </div>
        </div>
      )}
      {fax && (
        <div className="contact-address__contact-row">
          <Icon className="contact-address__icon">
            <FaxIcon />
          </Icon>
          <div className="contact-address__text">
            {fax}
          </div>
        </div>
      )}
    </div>
  </div>
);

ContactAddress.propTypes = {
  contactDetails: PropTypes.shape({
    address: PropTypes.array,
    fax: PropTypes.string,
    phone: PropTypes.string,
  }).isRequired,
};

export default ContactAddress;



// WEBPACK FOOTER //
// ./src/routes/Contact/components/ContactAddress/ContactAddress.js